import { getDefaultParams } from '@base/composables/useCustomI18n'
/**
 * `$t` with default parameters.
 */
export function overrideI18nTranslate() {
  const nuxtApp = useNuxtApp()
  const originalTranslate = nuxtApp.vueApp.config.globalProperties.$t
  // @ts-expect-error, expect error
  nuxtApp.vueApp.config.globalProperties.$t = function (
    key: string,
    params: { [key: string]: unknown },
  ): string {
    const defaultParams = getDefaultParams()
    // Merge the passed parameters with the default parameters
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const finalParams: Record<string, any> = { ...defaultParams, ...params }

    // Call the original $t method
    // @ts-expect-error, expect error
    return originalTranslate.call(this, key, finalParams)
  }
}
